import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {LandingComponent} from "./components/landing/landing.component";
import {EventsManager} from "./events/events.manager";
import {PlansService} from "./services/plans.service";
import * as _ from "underscore";
import { DataService } from './services/data.service';
import { SupportInformation } from './models/SupportInformation.model';
import {environment} from "../environments/environment";
import { LegalModel } from './models/legal.model';
import { ErrorService } from './services/error.service';
import {BenefitPlanTemplateModel, MainPageDetailModel, PlanOptionModel} from './models/plans.model';
import {StateSelectionComponent} from "./components/modals/state-selection/state-selection.component";
import {UtilService} from "./services/util.service";
import {StateModel} from "./models/state.model";
import {StateRequest} from "./models/state.request";
import { Info } from "./models/info.model";
import {MarketingDetailsRequest} from "./models/MarketingDetailRequest";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  office?: MainPageDetailModel = undefined;
  geoSaved:boolean = false;
  showSubHeader: boolean = true;
  legal:any = {};
  adminBy:string = '';
  savingsDetails:any = {};

  constructor(public modalService: NgbModal,
     private route: ActivatedRoute,
     private em: EventsManager,
     private service: PlansService,
     private dataService: DataService,
     private utilSrvc: UtilService,
     private errorService: ErrorService, private utils:UtilService) {

  }
  ngOnInit() {
    let host:string = window.location.host;
    window.scrollTo(0,0);
    //this never changes so its hard coded
    this.em.orgId = '5068093D-AA1F-41F8-AC42-1FC85A92B766';
    const planName = 'Smile Generation Dental Plan';
    this.service.getSellableStatesByPlan(planName).subscribe(
      (states:any) => {
        this.em.allowedStates = this.utilSrvc.setAllowedStates(states);
      }
    )
    if(!sessionStorage['state']){
      this.openStateModal();
    } else {
      this.getPlansByState();
    }

    this.em.showHideSubheader.subscribe((data:boolean) =>{
      this.showSubHeader = data;
    });

    this.utils.getStates().subscribe(
      (states:StateModel[]) => {
        this.em.setStates(states);
      }
    )

    this.service.getContactDetails('sgdp').subscribe(
      (result:any) => {
        this.em.contactInfo = result;
        this.em.contactInfoUpdated.emit();
      }
    )

    window.addEventListener("message", this.receiveMessage, false);
  }
  receiveMessage = (event: any) => {
    const message = event.data.message;
    if(message === 'scrollMe'){
      window.scrollTo(0,0);
      //@ts-ignore
      //document.getElementById('purchase').scrollTo(0,-1000);
    }

  }
  ngAfterViewInit(){
    console.log('scrollY: ', -window.scrollY);
    window.scroll(0,0);
  }
  ngOnDestroy(){
    sessionStorage['state'] = null;
  }
  openStateModal():void {
    const modalRef: NgbModalRef = this.modalService.open(StateSelectionComponent);
    modalRef.result.then(
      (result: any) => {
        this.getPlansByState();
        this.closeModal();
      },
      error => {
        console.log('dia error: ', error);
      }
    )
  }

  closeModal() {
    // need stuff here
    this.modalService.dismissAll();
    if(window.scrollY > 0){
      window.scrollTo(0,0);
    }
  }

  getPlansByState(){
    this.em.selectedState = JSON.parse(sessionStorage['state']);
    let planPrefix:string = 'Smile Generation Dental Plan';

    let req: StateRequest = {Organization: this.em.orgId,PlanPrefix:planPrefix,State:this.em.selectedState.abbr}
    this.service.getPlanDetails(req).subscribe(
      (result:BenefitPlanTemplateModel) => {
        //console.log('options: ', result);
         this.em.planOptions = result;
         let splitName:any = this.em.planOptions.templates[0].planName.split(' ');
         this.em.planYear = splitName[splitName.length-1];
         this.em.setIsAdminBy(this.em.planOptions.templates[0].isAdminBy);
         this.em.planId = this.em.planOptions.templates[0].benefitPlanTemplateId;
         this.getHomePageDetails();
      }
    )
  }

  getHomePageDetails(){
    let request:MarketingDetailsRequest = {pageName: 'home',planId:this.em.planId};
    this.service.getHomePageData(request).subscribe(
      (result:any) => {
        this.em.homePageDetails = result;
        this.em.homePageDetailUpdated.emit();
      }
    )
  }

}
